import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import styled from 'styled-components'
import { Slider } from 'components/Slider'
import { RadioButtons } from 'components/RadioButtons'

import { GroupDisplayBar } from 'components/GroupDisplayBar'
import { useEffect, useRef, useState } from 'react'
import lookup_income from './lookup_einkommen_ch.json'
import lookup_vermoegen from './lookup_vermoegen_ch.json'
import { cantons } from 'components/constants'
import { useMFContext } from 'components/MFHelpers'
import DynamicText from 'components/DynamicText'
import DynamicTextFR from 'components/DynamicText/DynamicText_FR'

const tenantCantonMap: { [key: string]: string } = {
  tagesanzeiger: 'ZH',
  bernerzeitung: 'BE',
  derbund: 'BE',
  bazonline: 'BS',
  berneroberlaender: 'BE',
  thunertagblatt: 'BE',
  langenthalertagblatt: 'BE',
  zsz: 'ZH',
  landbote: 'ZH',
  zuonline: 'ZH',
  tdg: 'GE',
  '24heures': 'GE',
}

const society_groups: [number, number, string][] = [
  [0, 0.1, 'Armut'],
  [0.1, 0.25, 'Armutsgefährdet'],
  [0.25, 0.5, 'Untere Mitte'],
  [0.5, 0.75, 'Mitte'],
  [0.75, 0.9, 'Obere Mitte'],
  [0.9, 2, 'Reich'],
]


const Form = () => {
  const { tenantKey, isMobile, windowHeight,_t,currentLanguage } = useMFContext()
  const chartEndRef = useRef<HTMLDivElement>(null)

  const [currentGroup, setCurrentGroup] = useState<number | undefined>(
    undefined
  )
  const tenantCanton = cantons.find(
    (f) => f.label === tenantCantonMap[tenantKey]
  )
  const locales = {
    radiobuttongroups: {
      einkommen: {
        label: _t('income_label'),
        subline: (
          <>
            {_t('income_subline_1')}
            <b>{_t('income_subline_2')}</b>{' '}
          </>
        ),
        info: _t('income_info'),
      },
      vermoegen: {
        label: _t('vermoegen_label'),
        subline: (
          <>
            {_t('vermoegen_subline_1')}
            <b>{_t('vermoegen_subline_2')}</b>{' '}
          </>
        ),
        info: _t('vermoegen_info'),
      },
      adultsinhousehold: {
        label: _t('adults_in_household'),
      },
      kidsinhousehold: {
        label: _t('kids_in_household'),
      },
      kanton: {
        label: _t('canton'),
      },
      age: {
        label: _t('age'),
      },
    },
  }
  const [state, setState] = useState<{ [key: string]: number }>({
    einkommen: 50000,
    adultsinhousehold: 1,
    age: 18,
    kidsinhousehold: 0,
    kanton: tenantCanton ? tenantCanton.value : 0,
    vermoegen: 0,
  })

  function calculateGroupCombined(state: { [key: string]: number }) {
    const { age, einkommen, vermoegen, adultsinhousehold } = state

    var wy = 0.5
    var wx = 0.5

    if (age === 65) {
      wy = 0.7
      wx = 0.3
    }

    let equivalentIncome = einkommen / adultsinhousehold

    var percentil_income = 0
    var percentil_vermoegen = 0

    var income_percentil_id = 0

    lookup_income.forEach(({ p, threshold }: any, i) => {
      if (equivalentIncome > threshold) {
        income_percentil_id = i
        percentil_income = p
        return
      }
    })

    var vermoegen_percentil_id = 0
    lookup_vermoegen.forEach(({ p, threshold }: any, i) => {
      if (vermoegen > threshold) {
        percentil_vermoegen = p
        vermoegen_percentil_id = i
        return
      }
    })

    let pos_in_society = percentil_income * wx + percentil_vermoegen * wy

    let group_index = 0
    society_groups.forEach((group, i) => {
      if (pos_in_society > group[0] && pos_in_society <= group[1])
        group_index = i
    })

    setCurrentGroup(group_index as number)
    console.log('emit')
    var event = new CustomEvent('percentiles', {
      detail: {
        percentiles: [percentil_income, percentil_vermoegen],
      },
    })
    console.groupEnd()
    window.dispatchEvent(event)
  }
  const handleChange = (id: string, e: number) => {
    const newState = { ...state, [id]: e }
    setState(newState)
    calculateGroupCombined(newState)
  }
  useEffect(() => {
    calculateGroupCombined(state)
  }, [state])

  return (
    <>
      <TextWidthExtended>
        <Center>
          <Title>{_t('form_title')}</Title>
          <Disclaimer>
            <span>{_t('form_disclaimer')}</span>
          </Disclaimer>
          <Slider
            range={[1, 200000]}
            step={1000}
            current={state.einkommen}
            stateProp='einkommen'
            onChange={handleChange}
            label={locales.radiobuttongroups.einkommen.label+""}
            subline={locales.radiobuttongroups.einkommen.subline}
            info={locales.radiobuttongroups.einkommen.info+""}
            unit={' Fr.'}
          />
          <Slider
            range={[0, 2000000]}
            step={5000}
            current={state.vermoegen}
            stateProp='vermoegen'
            onChange={handleChange}
            label={locales.radiobuttongroups.vermoegen.label+""}
            subline={locales.radiobuttongroups.vermoegen.subline}
            info={locales.radiobuttongroups.vermoegen.info+""}
            unit={' Fr.'}
          />

          <RadioButtons
            label={_t('age_group')+""}
            current={state.age}
            options={[
              { label: _t('age_group_1'), value: 18 },
              { label: _t('age_group_2'), value: 65 },
            ]}
            onClick={handleChange}
            stateProp='age'
          />

          <ButtonWrapper>
            <Button
              onClick={() => {
                if (chartEndRef.current) {
                  chartEndRef.current.scrollIntoView({
                    block: 'end',
                    behavior: 'smooth',
                  })
                }
              }}
            >
              {_t('show_chart')}
            </Button>
          </ButtonWrapper>
        </Center>
      </TextWidthExtended>
      <TextWidth>
        <GroupDisplayBar
          income={state.einkommen}
          wealth={state.vermoegen}
          userAge={state.age}
          userCanton={cantons[state.kanton].labelLong}
          isOn={true}
          userPosition={
            currentGroup
              ? society_groups.length - 1 - currentGroup
              : society_groups.length - 1
          }
          iconColors={[
            'var(--brandblue-bright-1)',
            'var(--brandblue-bright-1)',
          ]}
          hideLabel={false}
        />
      </TextWidth>
      <BottomSpaceWrapper>
        <ChartEnd
          ref={chartEndRef}
          style={{
            top: isMobile
              ? windowHeight * 0.1 + 'px'
              : windowHeight * 0.2 + 'px',
          }}
        />
      </BottomSpaceWrapper>
      <TextWidth>
       {currentLanguage === 'de' ? <>
          {(currentGroup || currentGroup === 0) && (
            <DynamicText group={currentGroup} age={state.age} />
          )}
        </> : <>
          {(currentGroup || currentGroup === 0) && (
            <DynamicTextFR group={currentGroup} age={state.age} />
          )}
        </>}
      </TextWidth>
    </>
  )
}

export default Form

const ButtonWrapper = styled.div`
  width: 100%;
`
const Button = styled.button`
  max-width: 200px;
  background-color: var(--text-color);
  color: var(--site-background);
  font-size: 18px;
  padding: 15px;
  letter-spacing: 0.4px;
  border: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  @media screen and (min-width: 712px) {
    &:hover {
      background-color: var(--yellow-main);
      cursor: pointer;
    }
  }
`

const BottomSpaceWrapper = styled.div`
  position: relative;
`
const ChartEnd = styled.div`
  position: absolute;
  top: 10px;
`
const Center = styled.div`
  background-color: var(--userinput-bg);
  margin-left: auto;
  margin-right: auto;
  color: var(--text-color);
  margin-top: 30px;
  margin-bottom: 90px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  row-gap: 0;
  padding: 30px;
  /* border: 1px solid var(--gray-4); */
  -webkit-box-shadow: var(--userinput-bg-shadow);
  box-shadow: var(--userinput-bg-shadow);
  .inputgroup:not(.title) {
    flex: 0 0 calc(50% - 15px);
    &:last-of-type {
      flex: 0 0 calc(100%);
    }
  }
  @media screen and (max-width: 801px) {
    .inputgroup:not(.title) {
      flex: 0 0 calc(100%);
      &:last-of-type {
        flex: 0 0 calc(100%);
      }
    }
  }
`

const Title = styled.div`
  flex: 0 0 100%;
  font-size: 26px;
  line-height: 1.4em;
  font-weight: 200;
  letter-spacing: 0.6px;
  text-align: center;
  margin-bottom: 5px;
  @media screen and (max-width: 712px) {
    font-size: 22px;
  }
`

const Disclaimer = styled.div`
  font-size: 13px;
  line-height: 1.4em;
  width: 100%;
  color: var(--gray-2);
  margin-bottom: 30px;
  span {
    display: inline-block;
    padding: 2px 15px;
    /* background-color: var(--yellow-main); */
  }
`
